import { Component, OnInit } from '@angular/core';
import { WgisService } from '../wgis/wgis.service';
import { Router} from '@angular/router';
import { Angulartics2 } from 'angulartics2';


@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html'
})
export class FaqsComponent implements OnInit {

  constructor(
    private wgisservice: WgisService,
    private router: Router,
    private angulartics2: Angulartics2
  ) {
    this.wgisservice.setMapInvisible();

    this.angulartics2.eventTrack.next({ 
      action: 'onClick', 
      properties: {label : 'FaqsGotoHome' },
    });
  }

  ngOnInit() {
  }

  onClick(){
    this.router.navigate(['/']);
  }

}
